// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/estoque/hooks/useEstoquePosicao.ts
// ════════════════════════════════════════════════════════════════════════════

import { useQuery } from '@tanstack/react-query';
import { estoqueService } from '../services/estoqueService';
import { apiClient } from '@/lib/apiClient';

// ── Resumo do estoque (KPIs do dashboard) ─────────────────────────────────

export interface EstoqueResumo {
  totalProdutos:     number;
  produtosEmAlerta:  number;
  valorTotalEstoque: number;
  produtosVencendo:  number;
}

export const useEstoqueResumo = () =>
  useQuery({
    queryKey: ['estoque-resumo'],
    queryFn:  async () => {
      const { data } = await apiClient.get<EstoqueResumo>('/api/estoque/resumo');
      return data;
    },
  });

interface UsePosicaoParams {
  pagina?: number;
  tamanhoPagina?: number;
  busca?: string;
  localId?: number;
}

export const useEstoquePosicao = ({
  pagina = 1,
  tamanhoPagina = 20,
  busca,
  localId = 0,
}: UsePosicaoParams = {}) =>
  useQuery({
    queryKey: ['estoque-posicao', pagina, tamanhoPagina, busca, localId],
    queryFn:  () => estoqueService.getPosicao(pagina, tamanhoPagina, busca, localId),
  });

export const useEstoqueReposicao = () =>
  useQuery({
    queryKey: ['estoque-reposicao'],
    queryFn:  estoqueService.getReposicao,
  });
